<template>
  <div>
    <TeJobDatascienceCover />

    <TeJobAbout>
      <template #title>
        データサイエンス
      </template>
      <template #content>
        <p class="co-display-10 mb-3 text-co-gray-500">
          データサイエンスの学習プログラムにおいて
          <br class="hidden md:block">
          受講生の「わからない」をリモートにてサポートしていただきます。
          <br class="hidden md:block">
          あなたのスキルを受講生の成長に活かしてみませんか？
        </p>
        <a href="/job">
          テックアカデミーのメンターについて
        </a>
      </template>
    </TeJobAbout>

    <TeJobTarget />

    <TeJobMessage>
      <template #mentoringText>
        1回30分のビデオチャットで受講生からの相談や質問に答えていただきます。
        <br class="hidden md:block">
        時にはペアプログラミングなどのサポートをしていただきます。
        <br class="hidden md:block">
        マンツーマンメンタリングはカリキュラムやチャットで解決できなかった課題を確実に解消させる取り組みです。
      </template>
      <template #chatsupportText>
        15時〜23時の間のシフト制で、
      </template>
    </TeJobMessage>

    <TeJobWorkStyle />

    <TeJobMentor>
      <template #mentorOne>
        <div class="basis-full px-4 text-center md:basis-1/4">
          <img
            src="~/assets/images/Te/TeJob/Mentor/mentor-ota.jpg"
            class="mx-auto mb-5 w-1/4 rounded-full md:mb-0 md:w-full"
            alt="Kazuki Ota"
            loading="lazy"
          >
        </div>
        <div class="basis-full px-0 text-left md:basis-3/4 md:px-4">
          <h4 class="co-display-10 text-center md:text-left">
            Kazuki Ota
          </h4>
          <p>
            システムエンジニア歴約20年、プログラミング歴約35年。プログラミングの守備範囲は、フロントエンド、サーバサイド、Android開発と広く、また、普段はシステム開発プロジェクトの管理や後輩の指導を行っています。
          </p>
        </div>
      </template>
      <template #mentorTwo>
        <div class="basis-full px-4 text-center md:basis-1/4">
          <img
            src="~/assets/images/Te/TeJob/Mentor/mentor-genichiro-shimizu.jpg"
            class="mx-auto mb-5 w-1/4 rounded-full md:mb-0 md:w-full"
            alt="Genichiro Shimizu"
            loading="lazy"
          >
        </div>
        <div class="basis-full px-0 text-left md:basis-3/4 md:px-4">
          <h4 class="co-display-10 text-center md:text-left">
            Genichiro Shimizu
          </h4>
          <p>
            企業勤務の研究者。これからの研究開発に必要な技術であると考え、機械学習・データサイエンスを独学で学びました。進歩の著しい分野ですので、常に最新の技術に目を向け、謙虚に学び続ける姿勢を大切にしています。
          </p>
        </div>
      </template>
    </TeJobMentor>

    <TeJobMentorSlider />

    <!-- スキル -->
    <section
      id="skill"
      class="co-bg-striped"
    >
      <div class="co-container-lg px-4 pb-[3.75rem] pt-20 lg:pb-10">
        <h2 class="co-heading-2">
          データサイエンスメンターに必要なスキル
        </h2>
        <div class="grid grid-cols-1 justify-center gap-9 lg:grid-cols-2 lg:gap-x-8 lg:gap-y-10">
          <TeJobSkill>
            <template #icon>
              <img
                src="~/assets/images/Te/TeJob/Skill/curriculum-python.png"
                alt="Python"
                width="48"
                loading="lazy"
              >
            </template>
            <template #title>
              Python
            </template>
            <template #description>
              Pythonの業務経験1年以上、または同等のスキルがある方
            </template>
          </TeJobSkill>
          <TeJobSkill>
            <template #icon>
              <img
                src="~/assets/images/Te/TeJob/Skill/curriculum-scikit-learn.png"
                alt="scikit-learn"
                width="48"
                loading="lazy"
              >
            </template>
            <template #title>
              scikit-learn
            </template>
            <template #description>
              Pythonで書かれたオープンソース機械学習ライブラリ
            </template>
          </TeJobSkill>
          <TeJobSkill>
            <template #icon>
              <img
                src="~/assets/images/Te/TeJob/Skill/curriculum-pandas.png"
                alt="Pandas"
                width="48"
                loading="lazy"
              >
            </template>
            <template #title>
              Pandas
            </template>
            <template #description>
              データの集計・分析を行う際に利用されるPythonのライブラリ
            </template>
          </TeJobSkill>
          <TeJobSkill>
            <template #icon>
              <img
                src="~/assets/images/Te/TeJob/Skill/curriculum-numpy.png"
                alt="NumPy"
                width="48"
                loading="lazy"
              >
            </template>
            <template #title>
              NumPy
            </template>
            <template #description>
              数値計算を効率的に行うためのライブラリ
            </template>
          </TeJobSkill>
        </div>
      </div>
    </section>

    <TeJobFlow />

    <TeJobEntry course-name-path="datascience" />
  </div>
</template>

<script setup lang="ts">
import { metaTags } from '~/utility/constants/metaTags'

import TeJobDatascienceCover from '~/components/Te/TeJob/Datascience/TeJobDatascienceCover.vue'
import TeJobAbout from '~/components/Te/TeJob/TeJobAbout.vue'
import TeJobTarget from '~/components/Te/TeJob/TeJobTarget.vue'
import TeJobMessage from '~/components/Te/TeJob/TeJobMessage.vue'
import TeJobWorkStyle from '~/components/Te/TeJob/TeJobWorkStyle.vue'
import TeJobMentor from '~/components/Te/TeJob/TeJobMentor.vue'
import TeJobMentorSlider from '~/components/Te/TeJob/TeJobMentorSlider.vue'
import TeJobSkill from '~/components/Te/TeJob/TeJobSkill.vue'
import TeJobFlow from '~/components/Te/TeJob/TeJobFlow.vue'
import TeJobEntry from '~/components/Te/TeJob/TeJobEntry.vue'

useJobHead()

useHead({
  title: 'データサイエンスメンター（講師）の募集 |テックアカデミー',
  meta: [
    ...metaTags({
      description:
        '受講生をサポートするデータサイエンスメンター（講師）の募集ページ。在宅・リモートで全国どこからでも仕事ができ、時間も柔軟に対応可能。自身のプログラミングスキルを活用したい場合は、まずはお気軽にご応募ください。',
      twitterTitle: 'データサイエンスメンター（講師）の募集',
      twitterDescription:
        '受講生をサポートするデータサイエンスメンター（講師）の募集ページ。在宅・リモートで全国どこからでも仕事ができ、時間も柔軟に対応可能。自身のプログラミングスキルを活用したい場合は、まずはお気軽にご応募ください。',
      twitterImage: '/_nuxt/ogp/og-image-mentor-datascience.jpg',
      ogTitle: 'データサイエンスメンター（講師）の募集',
      ogDescription:
        '受講生をサポートするデータサイエンスメンター（講師）の募集ページ。在宅・リモートで全国どこからでも仕事ができ、時間も柔軟に対応可能。自身のプログラミングスキルを活用したい場合は、まずはお気軽にご応募ください。',
      ogUrl: '/job/datascience',
      ogImage: '/_nuxt/ogp/og-image-mentor-datascience.jpg',
    }),
  ],
})
</script>
